import { ZoomMinusIcon } from '@velasca/icons/zoom-minus'
import { MagnifyButton } from '../MagnifyButton/MagnifyButton'
import type { ZoomButtonProps } from './ZoomButton.types'

export const ZoomButton = ({
  onClick,
  action,
}: ZoomButtonProps): JSX.Element | null => {
  if (action === 'open') {
    return null // No button rendered for 'open' action
  }

  return (
    <MagnifyButton action={action} onClick={onClick}>
      <ZoomMinusIcon />
    </MagnifyButton>
  )
}
